import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { IMainState } from 'store/states'
import { IntegrationTypes } from 'models/integrations'

export const useHasSence = () => {
  const integrations = useSelector(
    ({ general }: IMainState) => general.integrations.list
  )

  const hasSence = useMemo(
    () =>
      integrations.some(
        (item) => item.active && item.integrationType === IntegrationTypes.sence
      ),
    [integrations]
  )
  return hasSence
}
